import Vue from 'vue'
import axios from 'axios';

export var http = axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	headers: {
		Authorization: 'bearer ' + localStorage.getItem("token"),
		idi: localStorage.getItem("current_idi")
	}
})